import React from "react";

interface IRDPProviderProps {
    children?: React.ReactNode | React.ReactNode[];
}

export const RDPProvider = ({ children }: IRDPProviderProps) => <div>{children}</div>;
